import React from 'react';
import '../less/list.less';
import western_union_logo from '../img/list/western_union_logo.svg';
import ria_logo from '../img/list/ria_logo.svg';
import moneygram_logo from '../img/list/moneygram_logo.svg';
import swift_logo from '../img/list/swift_logo.svg';
import sepa_logo from '../img/list/sepa_logo.svg';
import intelexpress_logo from '../img/list/intelexpress_logo.svg';
import payoneer_logo from '../img/list/payoneer_logo.svg';
import remitbee_logo from '../img/list/remitbee_logo.svg';
import globus_logo from '../img/list/globus_logo.svg';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import localInternationalTransfersConfig from '../enums/list/local_international_transfers.json';
import cardTransfers from '../enums/list/card_transfers.json';
import ProductList from '../../../../../auxiliary-components/shared/ProductList';

export default function template() {
  const page = 'transfers-new-list';

  const imagesMap = {
    western_union_logo,
    ria_logo,
    moneygram_logo,
    swift_logo,
    sepa_logo,
    intelexpress_logo,
    payoneer_logo,
    remitbee_logo,
    globus_logo
  };

  const localInternationalTransfers = localInternationalTransfersConfig.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="transfers-new">
      <ProductList
        title="TRANSFERS_NEW_TITLE_01"
        items={localInternationalTransfers}
        page={page}
      />
      <ProductList
        title="TRANSFERS_NEW_TITLE_02"
        titleTag="h2"
        itemTitleTag="h3"
        items={cardTransfers}
        page={page}
      />
      <FilesForDownloadNew
        widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
        loader={this.state.loader}
      />
    </div>
  );
}
